import { SelectChangeEvent } from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { ClinicalCharacteristicsDomainOptions, CharacteristicTypeOptions } from '../constants';

export const useCohortCharacteristicsHeader = () => {
  const intl = useIntl();

  const [selectedCharacteristicsType, setSelectedCharacteristicsType] = useState<string | null>(
    CharacteristicTypeOptions[1].value
  );
  const [selectedDomain, setSelectedDomain] = useState<string | null>(null);
  const onCharacteristicsChange = (event: SelectChangeEvent<string>) => {
    setSelectedCharacteristicsType(event.target.value);
    if (event.target.value === CharacteristicTypeOptions[1].value) {
      setSelectedDomain(null);
    } else {
      setSelectedDomain(ClinicalCharacteristicsDomainOptions[0].value);
    }
  };
  const onDomainChange = (event: SelectChangeEvent<string>) => {
    setSelectedDomain(event.target.value);
  };

  const _ClinicalCharacteristicsDomainOptions = ClinicalCharacteristicsDomainOptions.map(
    (option) => ({
      ...option,
      displayValue: intl.formatMessage({
        id: option.displayValue,
      }),
    })
  );

  const _CharacteristicTypeOptions = CharacteristicTypeOptions.map((option) => ({
    ...option,
    displayValue: intl.formatMessage({
      id: option.displayValue,
    }),
  }));

  return {
    ClinicalCharacteristicsDomainOptions: _ClinicalCharacteristicsDomainOptions,
    CharacteristicTypeOptions: _CharacteristicTypeOptions,
    onCharacteristicsChange,
    selectedCharacteristicsType,
    selectedDomain,
    onDomainChange,
  };
};
